export default function imageCDNDomain() {
  return window.TC.Config.image_cdn_domain;
}
